export const dropdownMenu = {
  profile: "Persoonlike area",
  mobilePaidAccounts: "Mobiele betaalrekeninge",
  movements: "Transaksies",
  contact: "Kontakte",
  changePassword: "Verander wagwoord",
  inviteFriend: "Nooi 'n vriend",
  deposit: "Deposito's",
  withdrawal: "Onttrekking",
  transfer: "Oopskakel",
  logout: "Teken uit",
  points: "Punte",
  xpPoints: "XP",
  tokens: "Tokens",
  level: "Vlak",
  language: "Taal",
  backToPersonalArea: "Terug na persoonlike area",
};
